import { Switch, Route, Redirect } from "react-router-dom";
import { ROUTES } from "../core/constants/Routes";
import DashboardView from "../views/DashBoard/DashboardView";
import ValidationView from "../views/Validation/ValidationView";
import CompaniesView from "../views/Companies/CompaniesView";
import OldClientsView from "../views/OldClients/OldClientsView";
import VerificationView from "../views/Verification/VerificationView";
import { RequireAuth } from "../components/Auth/RequireAuth";
import LoginCallback from "../components/Login/LoginCallback";
import LogoutCallback from "../components/Logout/LogoutCallback";

export default function Routes() {
  return (
    <>
      <Switch>
        <Route path={ROUTES.LOGIN_CALLBACK} component={LoginCallback} />
        <Route path={ROUTES.LOGOUT_CALLBACK} component={LogoutCallback} />

        <RequireAuth>
          <>
            <Route path={ROUTES.INITIAL_ROUTE}>
              <Redirect to={ROUTES.DASHBOARD} />
            </Route>
            <Route exact path={ROUTES.DASHBOARD} component={DashboardView} />
            <Route
              exact
              path={ROUTES.AML_VALIDATION}
              component={ValidationView}
            />
            <Route exact path={ROUTES.COMPANIES} component={CompaniesView} />
            <Route exact path={ROUTES.OLD_CLIENTS} component={OldClientsView} />
            <Route
              exatc
              path={ROUTES.VERIFICATION}
              component={VerificationView}
            />
          </>
        </RequireAuth>
      </Switch>
    </>
  );
}
